<div class="offset-md-2 col-md-8">
  <img src="./assets/images/LogoExploreTXTIMAGE_small.jpg" alt="EXPLORE" />
</div>
<div class="offset-md-2 col-md-8" style="text-align:center">
  <!--<h3>Update Expertir to <b>V.2021.3.e</b>  and Expertab to <b>V.1.4.1</b> or above</h3>-->
</div>

@if (!utilChoixSite) {
  <div class="content-box-login offset-md-4 col-md-4">
    <!--<h2>ExplOre</h2>-->
    <form name="form">
      <div class="form-group">
        <label for="username">{{'GLOBAL.IDENTIFIANT' | translate}}</label>
        <input type="email" class="form-control" name="username" [(ngModel)]="username" autocomplete="username email" placeholder="{{'GLOBAL.IDENTIFIANT' | translate}}" autofocus />
        @if (usernameInvalide) {
          <div class="custom-alert custom-alert-sm">{{'CONNEXION.IDENTIFIANT_REQUIS' | translate}}</div>
        }
      </div>
      <div class="form-group">
        <label for="password">{{'GLOBAL.MOT_DE_PASSE' | translate}}</label>
        <input type="password" class="form-control" name="password" [(ngModel)]="password" placeholder="{{'GLOBAL.MOT_DE_PASSE' | translate}}" autocomplete="current-password" />
        @if (passwordInvalide) {
          <div class="custom-alert custom-alert-sm">{{'CONNEXION.MOT_DE_PASSE_REQUIS' | translate}}</div>
        }
      </div>
      @if (identifiantsInvalides) {
        <div class="custom-alert custom-alert-sm">{{'CONNEXION.IDENTIFIANTS_INVALIDES' | translate}}</div>
      }
      @if (compteBloque) {
        <div class="custom-alert custom-alert-sm">{{'CONNEXION.COMPTE_DESACTIVE' | translate}}</div>
      }
      @if (erreurConnexion) {
        <div class="custom-alert custom-alert-sm">{{'CONNEXION.ERREUR_CONNEXION' | translate}}</div>
      }
      @if (nonAutorise) {
        <div class="custom-alert custom-alert-sm">{{'CONNEXION.NON_AUTORISE' | translate}}</div>
      }
      <div class="btn-toolbar justify-content-between align-middle">
        <div class="btn-group" role="group">
          <button type="submit" class="btn btn-primary">{{'CONNEXION.SE_CONNECTER' | translate}}</button>
        </div>
        <div class="btn-group " role="group">
          <button type="button" class="btn btn-link" (click)="ouvrirFenetreMdpOublie(templateResetMdp)">{{'CONNEXION.MDP_OUBLIE' | translate}}</button>
        </div>
      </div>
    </form>
  </div>
}
@if (!utilChoixSite) {
  <div class="link-support">
    <a href="mailto:{{ emailSupport() }}">{{'CONNEXION.CONTACTER_SUPPORT' | translate}}</a>
  </div>
}
<ng-template #templateResetMdp>
  <div class="modal-body">
    <p>{{'CONNEXION.MESSAGE_EMAIL_OUBLIE' | translate}}</p>
    <form>
      <div class="form-group">
        <label for="email">{{'GLOBAL.IDENTIFIANT' | translate}}</label>
        <input type="email" id="email" class="form-control" name="email" [(ngModel)]="email" required autofocus />
        @if (mdpOublieEmailInvalide) {
          <div class="custom-alert custom-alert-sm">{{'CONNEXION.IDENTIFIANT_REQUIS' | translate}}</div>
        }
        @if (mdpOublieCompteBloque) {
          <div class="custom-alert custom-alert-sm">{{'CONNEXION.COMPTE_DESACTIVE' | translate}}</div>
        }
        @if (mdpOublieErreur) {
          <div class="custom-alert custom-alert-sm">{{'CONNEXION.MDP_OUBLIE_MESSAGE_ERREUR' | translate}}</div>
        }
      </div>
      <div class="btn-toolbar justify-content-between">
        <div class="btn-group" role="group">
          <button type="submit" class="btn btn-outline-success" (click)="demandeNouveauMdp()">{{'CONNEXION.ENVOYER' | translate}}</button>
        </div>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-outline-danger" (click)="annulerDemandeMdp()">{{'GLOBAL.ANNULER' | translate}}</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<div bsModal #modalChoixSite="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body">
        <p>{{'CONNEXION.CHOIX_SITE' | translate}}</p>
        <form>
          <div class="form-group">
            <label for="selectSite">{{'CONNEXION.SITES_DISPO' | translate}}</label>
            <ng-select id="selectSite" name="selectSite" [(ngModel)]="selectSite" [clearable]="false" [searchable]="false" (change)="selectionSite()">
              @for (site of siteSelectionnables(); track site) {
                <ng-option [value]="site">{{site.nom}}</ng-option>
              }
            </ng-select>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
